module.exports = __webpack_public_path__ + "img/404.2fdcd2fc.svg";